export default __webpack_public_path__ + "static/media/CFFundBanner.ee793b27.jpg";